
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.375 6h-2.737a12.805 12.805 0 0 0-1.29-1.617L21.25 3.206l-1.097 1.177A12.806 12.806 0 0 0 18.862 6H5.625A1.627 1.627 0 0 0 4 7.625V10a5.506 5.506 0 0 0 5 5.475v.025h7.973l-2.638 5.276a1.761 1.761 0 0 0-.185.783v6.691A1.752 1.752 0 0 0 15.9 30h3.85a1.752 1.752 0 0 0 1.75-1.75v-6.396l3.342-6.683.133-.266A5.502 5.502 0 0 0 28 10V7.625A1.627 1.627 0 0 0 26.375 6ZM20 21.559v6.691a.25.25 0 0 1-.25.25H15.9a.25.25 0 0 1-.25-.25v-6.691a.25.25 0 0 1 .026-.112L18.65 15.5h3.85c.173 0 .344-.01.513-.026l-2.987 5.973a.25.25 0 0 0-.026.112ZM22.5 14h-9.237A5.478 5.478 0 0 0 15 10V7.5h3.12a2.662 2.662 0 0 0-.12.75 3.25 3.25 0 1 0 6.5 0 2.662 2.662 0 0 0-.12-.75h1.995a.125.125 0 0 1 .125.125V10a4 4 0 0 1-4 4Zm-17-6.375a.125.125 0 0 1 .125-.125H13.5V10a4 4 0 1 1-8 0V7.625ZM23 8.25a1.75 1.75 0 0 1-3.5 0c0-.966 1.75-2.844 1.75-2.844S23 7.284 23 8.25Z"}})])
          )
        }
      }
    